<template>
  <div class="cardTicket-Add">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="卡券名称：" prop="ticketName">
        <el-input v-model="form.ticketName"></el-input>
      </el-form-item>
      <el-form-item label="卡券内容：" prop="ticketContent">
        <el-input v-model="form.ticketContent"></el-input>
      </el-form-item>
      <el-form-item label="卡券日期："  prop="date">
        <el-date-picker
          v-model="form.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
       <el-form-item label="发放账户：" prop="userIds">
         <el-select
          v-model="form.userIds"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="请输入手机号"
          :remote-method="remoteMethod"
          :loading="selectLoading"
          @change="handleChange">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.userName"
            :value="item.userName">
          </el-option>
        </el-select>
        <span style="color:grey;margin-left:10px;">(输入手机号可进行搜索)</span>
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" :loading="loading" @click="onSubmit('form')">保存</el-button>
        <el-button @click="$router.push({ name:'CardTicketList' })">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addAssistantTicket, getShopUserList } from '@/api/cardTicket';
import { validPhone } from '@/utils/validate';

export default {
  data() {
    return {
      loading: false,
      selectLoading: false,
      form: {
        ticketName: '',
        ticketContent: '',
        date: [],
        userIds: [],
      },
      options: [],
      rules: {
        ticketName: [
          { required: true, message: '请输入卡券名称', trigger: 'blur' },
        ],
        ticketContent: [
          { required: true, message: '请输入卡券内容', trigger: 'blur' },
        ],
        date: [
          { required: true, message: '卡券日期不能为空', trigger: 'change' },
        ],
        userIds: [
          { required: true, message: '发放账户不能为空', trigger: 'change' },
        ],
      },
    };
  },
  mounted() {
    this.getShopUserList();
  },
  methods: {
    // 获取会员下拉列表
    getShopUserList(query = '') {
      getShopUserList(query).then((res) => {
        if (res.success) {
          this.options = res.data;
          this.selectLoading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addAssistantTicket(ids) {
      this.loading = true;
      const { userIds, date, ...rest } = this.form;
      const [ticketBeginTime, ticketEndTime] = date;
      addAssistantTicket({
        ...rest,
        ticketBeginTime,
        ticketEndTime,
        userIds: ids.join(','),
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('添加成功');
          this.$router.push({
            name: 'CardTicketList',
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleChange() {
      this.getShopUserList();
    },
    onSubmit(formName) {
      const { userIds } = this.form;
      const ids = userIds.map((item) => {
        const obj = this.options.find((items) => items.userName === item);
        if (obj) {
          return obj.id;
        }
        return false;
      });
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addAssistantTicket(ids);
          return true;
        }
        return false;
      });
    },
    remoteMethod(query) {
      this.selectLoading = true;
      if (validPhone(query) || query === '') {
        this.getShopUserList(query);
      }
    },
    handleCancel() {
      this.$router.push({ name: 'CardTicketList' });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.cardTicket-Add
  padding-top 100px
  .el-form
    width 700px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      margin-top 30px
      text-align center
    >>>.el-date-editor .el-range-separator
      width 6%!important
>>>.el-select__tags
  .el-select__input
    min-width 100%
</style>
